export enum PackageViewMode {
	INDIVIDUAL = "individual",
	PACKAGE = "package",
}
